<template>
<div>
  <form>
    <columns>
      <column>
        <text-input 
          required
          :error="$root.errorBag.email"
          v-model="invite.email">Email Address</text-input>
      </column>
    </columns>  
    <columns>
      <column>
          <div class="columns">
            <div class="column">
              <h4 class="title is-5">Permissions</h4>
              <div class="box">
                <div class="columns" v-for="(permissions, category) in permissions" :key="category">
                  <div class="column">
                    <checkbox-group slug-values type="inline" :items="permissions" v-model="invite.permissions">
                      {{ category | ucwords }}
                    </checkbox-group>
                  </div>  
                </div>
              </div>
            </div>
          </div>
      </column>
    </columns>  
    <columns>
      <column>
        <submit-button :working="sending" @submit="sendInvite">Send Invitation</submit-button>
      </column>
    </columns>
  </form>  
</div>  
</template>
<script>
import { post, get } from '@/api/request'

export default {
  
  data: () => ({
    sending: false,
    invite: {
      email: '',
      permissions: []
    },
    permissions: []
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'New Team Invite')
    get('api/team-permissions', ({data}) => this.permissions = data)
  },

  methods: {
    sendInvite() {
      this.sending = true 
      post(`api/team/${this.$route.params.team}/invite`, this.invite, ({data}) => {
        this.$toast.success('Invitation sent')
        this.sending = false
        this.$router.back()
      }, error => {
        this.sending = false
      })
    }
  }

}
</script>